// extracted by mini-css-extract-plugin
module.exports = {"block":"header_block__fLlZL","content":"header_content__2Uc32 container","logo":"header_logo__1XiXi","tmdbLogo":"header_tmdbLogo__3kCI8"};